<template>
	<div class="footer">
		<div class="container">
			Copyright &copy; 2004-2018 {{tr.institute_of_world_economics_and_politics}}. {{tr.all_rights_reserved}}.
			<br/><span style='font-size:12px;'>{{tr.footer_second_text}}</span>
		</div>
	</div>
</template>

<script>
export default {
  name: 'i-footer',

  computed:{
    lang(){return this.$store.state.lang;},
    tr(){return this.$store.getters.translates;}
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="css" scoped>

.footer{
	/*background: #092e55;*/
	/*background: #135f84;*/
	padding:12px 0 ; 
	color:white;
	line-height: 1.4;
}
</style>